import React, { useState } from 'react';
import { 
  Box, 
  Toolbar, 
  Typography, 
  FormControl, 
  FormLabel, 
  RadioGroup, 
  FormControlLabel, 
  Radio, 
  Link,
  colors
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import axios from "axios";
import { useMode } from "../context/modeContext";

const Pform = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = useMode();
  
  // Extracting the number from location state
  const receivedNumber = location.state?.number || ''; 

  const [formData, setFormData] = useState({
    name: '',
    mobile: receivedNumber, // Pre-filling with the received tag/number
    dob: '',
    locationValue: '',
    gender: 'female' 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Box>
      <Toolbar>
        <div className='diclaimer-Screen'>
          <div className='formrapper'>
            <form onSubmit={handleSubmit} >
              <h2>{t("p_title")}</h2>

              {/* Mobile Number (Pre-filled with receivedNumber) */}
              <div className='form-lable-input'>
                <label>{t("p_mob")}</label>
                <input 
                  type="text" 
                  name="mobile" 
                  value={formData.mobile} 
                  disabled
                  readOnly // Prevents user from editing the received number
               />
              </div>

              {/* Name */}
              <div className='form-lable-input'>
                <label>{t("p_name")}</label>
                <input 
                  type="text" name="name" 
                  value={formData.name} onChange={handleChange} required 
                />
              </div>

              {/* Date of Birth */}
              <div className='form-lable-input'>
                <label>{t("p_dob")}</label>
                <input 
                  type="date" name="dob" 
                  value={formData.dob} onChange={handleChange} required 
                 
                />
              </div>

              {/* Gender */}
              <FormControl component="fieldset">
                <FormLabel  component="legend" style={{padding:'15px 0px 0px 0px',color:'#111'}}><b>{t("p_gender")}</b></FormLabel>
                <RadioGroup row name="gender" value={formData.gender} onChange={handleChange}>
                  <FormControlLabel value="male" control={<Radio />} label={t("p_male")} />
                  <FormControlLabel value="female" control={<Radio />} label={t("p_female")} />
                  <FormControlLabel value="other" control={<Radio />} label={t("p_other")} />
                </RadioGroup>
              </FormControl>

              {/* Location */}
              <div className='form-lable-input' >
                <label >{t("p_address")}</label>
                <textarea 
                   name="locationValue" 
                  value={formData.locationValue} onChange={handleChange} required 
                 
                />
              </div>
                   <div className='psubmit'>
              <Link component={RouterLink} to="/disclaimer" className='psubmit-back'>{t('back_btn')}</Link>
              <Link
                component="button"
                sx={{ marginTop: '30px' }}
                onClick={async () => {
                  try {
                    await axios.post("/api/updateUser_reg_complete", {
                      phone: receivedNumber,
                      page_state: mode,
                      name: formData.name,
                      dob: formData.dob,
                      gender: formData.gender,
                      address: formData.locationValue
                    }, { timeout: 10000 });
                
                    navigate("/chatbot", {
                      state: {
                         number: receivedNumber, 
                         name: formData.name,
                         dob: formData.dob,
                         gender: formData.gender,
                         address: formData.locationValue
                        }
                    });
                
                  } catch (err) {
                    console.error(err);
                    alert("Something went wrong");
                  }
                }
              }
              >
                {t('start_chat')}
              </Link>
              
              </div>
            </form>
          </div>
        </div>
      </Toolbar>
    </Box>
  );
};

export default Pform;